import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {IStore} from "../../../app/reducers/hybrid_reducer";
import {voivodeshipNames, Voivodeship} from "../../../app/types/locationTypes";
import {parseSearch} from "../../../app/utils/request_response_utils/parse_search";
import CarSearchFiltersForm from "../../../search/CarSearchFiltersForm";
import {searchValuesFromQuery} from "../../../search/search_filter_config";

/**
 * List-page filter bar. Kept in a separate module so CarListDynamic
 * (imported by meta-data actions) does not pull Formik search into a circular dep.
 */
export const CarListFilters = () => {
    const location = useLocation();
    const carMakeType = useSelector((store: IStore) => store.carList.latestQuery.type);
    const totalItems = useSelector((store: IStore) => store.carList.cars.totalItems);
    const listLocation = useSelector((store: IStore) => store.carList.location.location);
    const locationPLName = useSelector((store: IStore) => store.carList.locationPLName);

    const listFilterValues = searchValuesFromQuery(
        parseSearch(location.search) as Record<string, string | string[] | undefined>,
        carMakeType ? String(carMakeType).toLowerCase() : "",
        listLocation?.location || "",
        listLocation?.subLocation || ""
    );

    const cityLabel = listLocation?.subLocation
        ? locationPLName?.cityName || listLocation.subLocation
        : undefined;
    const voivodeshipLabel = listLocation?.location
        ? voivodeshipNames[listLocation.location as Voivodeship] || listLocation.location
        : undefined;
    const locationLabel = cityLabel || voivodeshipLabel;

    return (
        <CarSearchFiltersForm
            variant="list"
            initialValues={listFilterValues}
            locationLabel={locationLabel}
            initialCityLabel={cityLabel}
            initialCount={totalItems}
        />
    );
};
